// extracted by mini-css-extract-plugin
export default {"card":"Seller_card__+IAw4","text":"Seller_text__yFKTU","imageContainer":"Seller_imageContainer__gJAqb","image":"Seller_image__RNNGx","title":"Seller_title__hdBAA h2"};